import { assertKitchenResponse } from "./kitchenActions";

export const getCartProducts = (response) => {
  assertKitchenResponse(response);
  const cart = response?.data?.data?.data;
  if (!Array.isArray(cart?.cartProducts)) throw new Error("Unable to read preparation comments from the order cart.");
  return cart.cartProducts;
};

export const findTaskCartProduct = (task, job, products) => {
  const candidates = [task.metadata?.cartProductId, task.taskId, task.itemId].filter(Boolean).map(String);
  const exact = products.filter((product) => candidates.includes(String(product.cartProductId)));
  if (exact.length === 1) return exact[0];
  // Some older jobs only retain a product GTIN. Resolve it only if unambiguous
  // in both the cart and the job; never write to the wrong batch/variant.
  if (!task.externalId || job.tasks.filter((candidate) => candidate.externalId === task.externalId).length !== 1) return null;
  const matches = products.filter((product) => String(product.gtin) === String(task.externalId));
  return matches.length === 1 ? matches[0] : null;
};

export const preparationNoteKey = (jobId, taskId) => JSON.stringify([jobId, taskId]);
